import { render, staticRenderFns } from "./couponProList.vue?vue&type=template&id=44555fd1&"
import script from "./couponProList.vue?vue&type=script&lang=js&"
export * from "./couponProList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports